import Vue from 'vue'
import ImagePreviewer from '@/components/ImagePreviewer.vue'

export default {
  install (Vue) {
    const PreviewConstructor = Vue.extend(ImagePreviewer)
    const instance = new PreviewConstructor()
    instance.$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)

    Vue.prototype.$preview = (imgs, index = 0) => {
      instance.open(imgs, index)
    }
  }
}
